import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { Language } from '@/shared/entities/Language'
import type { Gender } from '@/shared/enums/genderEnum'

export class UserMiniEntity {
  id?: string
  uid?: string
  displayName?: string | null
  phoneNumber?: string | null
  photoUrl?: string | null
  gender?: Gender
  language?: Language
  regions?: RegionMiniEntity[] | null
  createdAt?: string
  disabled?: boolean
  isVip?: boolean
}
